/**
 * FireplaceImage — three portrait Eurosteel steel-door renders shown as a
 * clean 3-up gallery. Each tile shares the same aspect ratio, a slight
 * border, and consistent spacing.
 */
const IMAGES = [
  {
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_c8c33088-e275-4c7a-be4e-9570c082ca94/artifacts/d5qa77f7_IMG_4972.webp",
    alt: "Bespoke Eurosteel double doors framing a lit fireplace",
  },
  {
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_c8c33088-e275-4c7a-be4e-9570c082ca94/artifacts/g3zv09dj_IMG_4970.webp",
    alt: "Double steel doors with reeded glass detail",
  },
  {
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_c8c33088-e275-4c7a-be4e-9570c082ca94/artifacts/j8i7tzer_IMG_4971.webp",
    alt: "Slim-profile single steel door with fireplace room beyond",
  },
];

export const FireplaceImage = () => {
  return (
    <section
      id="fireplace-image"
      data-testid="fireplace-image-section"
      className="relative z-10 w-full overflow-hidden bg-[#f5f3ee] px-6 py-20 lg:px-12 lg:py-28"
    >
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
        {IMAGES.map((img, i) => (
          <div
            key={img.src}
            data-testid={`fireplace-image-tile-${i + 1}`}
            className="aspect-[4/5] overflow-hidden rounded-sm border border-black/15 bg-white shadow-sm ring-1 ring-black/5"
          >
            <img
              src={img.src}
              alt={img.alt}
              loading="lazy"
              className="h-full w-full object-cover"
            />
          </div>
        ))}
      </div>
    </section>
  );
};
